import { render, staticRenderFns } from "./PosterSchedule.vue?vue&type=template&id=8e927040&"
import script from "./PosterSchedule.vue?vue&type=script&lang=js&"
export * from "./PosterSchedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports